import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\AuthenticateController::__invoke
* @see app/Http/Controllers/Screen/AuthenticateController.php
* @route '/api/screen/login'
*/
const AuthenticateController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AuthenticateController.url(options),
    method: 'post',
})

AuthenticateController.definition = {
    methods: ["post"],
    url: '/api/screen/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Screen\AuthenticateController::__invoke
* @see app/Http/Controllers/Screen/AuthenticateController.php
* @route '/api/screen/login'
*/
AuthenticateController.url = (options?: RouteQueryOptions) => {
    return AuthenticateController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\AuthenticateController::__invoke
* @see app/Http/Controllers/Screen/AuthenticateController.php
* @route '/api/screen/login'
*/
AuthenticateController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AuthenticateController.url(options),
    method: 'post',
})

export default AuthenticateController